import { render, staticRenderFns } from "./YTtitle.vue?vue&type=template&id=3c1df494"
import script from "./YTtitle.vue?vue&type=script&lang=js"
export * from "./YTtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports